// Resuelve el subdominio del tenant actual a partir del hostname del browser.
// Se usa para inyectar el header X-Tenant-Subdomain en cada request al
// backend, que lo necesita cuando el front se sirve desde Cloudflare Pages
// (donde el Host del request al API ya no contiene el subdominio del cliente).

const SUBDOMAIN_RE = /^[a-z0-9-]+$/;

/**
 * Extrae el subdominio de un hostname, relativo a un baseHost dado.
 *
 * Ejemplos:
 *   extractSubdomain('acme.stiltech.cl', 'stiltech.cl') → 'acme'
 *   extractSubdomain('stiltech.cl', 'stiltech.cl') → null (root, sin sub)
 *   extractSubdomain('localhost', 'lvh.me') → null (no matchea baseHost)
 *   extractSubdomain('deep.acme.stiltech.cl', 'stiltech.cl') → 'acme' (último nivel antes del base)
 *
 * Si el último nivel antes del baseHost contiene chars fuera de [a-z0-9-],
 * retorna null — evita inyectar valores raros al back.
 */
export function extractSubdomain(hostname, baseHost) {
  if (!hostname || !baseHost) return null;
  const h = String(hostname).toLowerCase();
  const b = String(baseHost).toLowerCase();
  if (h === b) return null;
  if (!h.endsWith(`.${b}`)) return null;
  const prefix = h.slice(0, -(b.length + 1));
  if (!prefix) return null;
  const parts = prefix.split('.');
  const tail = parts[parts.length - 1];
  if (!tail || !SUBDOMAIN_RE.test(tail)) return null;
  return tail;
}

/**
 * Devuelve el subdominio del tenant del browser actual, o null si no aplica
 * (SSR, hostname no matchea baseHost, config ausente).
 */
export function getCurrentSubdomain() {
  if (typeof window === 'undefined' || !window.location) return null;
  const baseHost = import.meta.env?.VITE_BASE_HOST;
  return extractSubdomain(window.location.hostname, baseHost);
}
